module.exports = __webpack_public_path__ + "img/vacation.537f4a14.png";